import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import {
    GET_EXAM_BOARD_LIST,
    SET_EXAM_BOARD_LIST_LOADING,
    SET_EXAM_BOARD_BY_ID,
    GET_EXAM_BOARD_YEARS,
    GET_EXAM_BOARD_KURSES,
    SET_EXAM_BOARD_TRAJECTORIES_BY_ID,
    SET_EXAM_BOARD_INTERVIEWS_BY_ID,
    SET_EXAM_BOARD_INTERVIEWERS_BY_ID,
    SET_EXAM_BOARD_INTERVIEWERS_ALL
} from "./types";

export const getExamBoardList = (filters) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_EXAM_BOARD_LIST_LOADING, payload: true });
        const { data } = await api.get(`/exam_board/${filters.school_year}/${filters.stream}/${filters.kurs}`);
        dispatch({ type: GET_EXAM_BOARD_LIST, payload: data });
    } catch (error) {
        console.error('Error in exam_board action:', error);
        dispatch({ type: GET_EXAM_BOARD_LIST, payload: [] });
    } finally {
        dispatch({ type: SET_EXAM_BOARD_LIST_LOADING, payload: false });
    }
};

export const updateExamBoard = (data) => async (dispatch, getState) => {
    try {
        await api.put(`/exam_board/${data.id}`, data);
        await dispatch(getExamBoardList({ school_year: data.school_year, stream: data.stream, kurs: data.kurs }));
        createNotification('success', 'Успешно!');
    } catch (error) {
        console.error('Error in exam_board action:', error);
    }
}

export const createExamBoard = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/exam_board`, data);
        createNotification('success', 'Успешно');
        await dispatch(getExamBoardList({ school_year: data.school_year, stream: data.stream, kurs: data.kurs }));
    } catch (error) {
        console.error('Error in exam_board action:', error);
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteExamBoard = (id, filters) => async (dispatch, getState) => {
    try {
        await api.delete(`/exam_board/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getExamBoardList(filters));
    } catch (error) {
        console.error('Error in exam_board action:', error);
        createNotification('error', error.message || 'Произошла ошибка');
    }
};

export const updateExamBoardAddress = (city_id, params) => async (dispatch, getState) => {
    try {
        await api.put(`/exam_board/address/${params.id}`, params);
        await dispatch(getExamBoardItem(city_id));
        createNotification('success', 'Успешно!');
    } catch (error) {
        console.error('Error in exam_board action:', error);
    }
}

export const createExamBoardAddress = (city_id, data) => async (dispatch, getState) => {
    try {
        await api.post(`/exam_board/${city_id}/address`, data);
        createNotification('success', 'Успешно');
        await dispatch(getExamBoardItem(city_id));
    } catch (error) {
        console.error('Error in exam_board action:', error);
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteExamBoardAddress = (id, city_id) => async (dispatch, getState) => {
    try {
        await api.delete(`/exam_board/address/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getExamBoardItem(city_id));
    } catch (error) {
        console.error('Error in exam_board action:', error);
        createNotification('error', error.message || 'Произошла ошибка');
    }
};

export const getExamBoardItem = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/exam_board/${id} `);
        dispatch({ type: SET_EXAM_BOARD_BY_ID, payload: data });
    } catch (error) {
        console.error('Error in exam_board action:', error);
    }
};

export const getExamBoardItemTrajectories = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/xp_trajectories`);
        dispatch({ type: SET_EXAM_BOARD_TRAJECTORIES_BY_ID, payload: data });
    } catch (error) {
        console.error('Error in exam_board action:', error);
    }
};

export const getExamBoardItemInterviews = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/exam_board/interviews/${id} `);
        dispatch({ type: SET_EXAM_BOARD_INTERVIEWS_BY_ID, payload: data });
    } catch (error) {
        console.error('Error in exam_board action:', error);
    }
};

export const getExamBoardItemInterviewers = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/exam_board/interviewers/${id} `);
        dispatch({ type: SET_EXAM_BOARD_INTERVIEWERS_BY_ID, payload: data });
    } catch (error) {
        console.error('Error in exam_board action:', error);
    }
};

export const getExamBoardItemInterviewersAll = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/exam_board/add_interviewers/${id}`);
        dispatch({ type: SET_EXAM_BOARD_INTERVIEWERS_ALL, payload: data });
    } catch (error) {
        console.error('Error in exam_board action:', error);
    }
};

export const editExamBoardItemInterviewers = (board_member_id, mid, data, itemId) => async (dispatch, getState) => {
    try {
        await api.put(`/exam_board/interviewers/${board_member_id}/${mid}`, data);
        createNotification('success', 'Успешно');
        await dispatch(getExamBoardItemInterviewers(itemId));
    } catch (error) {
        console.error('Error in exam_board action:', error);
        createNotification('error', "Не удалось создать запись");
    }
};

export const editExamBoardItemInterviewersRole = (board_member_id, data) => async (dispatch, getState) => {
    try {
        await api.put(`/exam_board/interviewers/${board_member_id}`, data);
        createNotification('success', 'Успешно');
        await dispatch(getExamBoardItemInterviewers(board_member_id));
    } catch (error) {
        console.error('Error in exam_board action:', error);
        createNotification('error', "Не удалось создать запись");
    }
};



//FILTERS

export const getYears = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/school_year`);
        dispatch({ type: GET_EXAM_BOARD_YEARS, payload: data.school_year });
    } catch (error) {
        console.error('Error in exam_board action:', error);
        dispatch({ type: GET_EXAM_BOARD_YEARS, payload: [] });
    }
};

export const getKurses = (kursID) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/exam_board/kurs/${kursID}`);
        dispatch({ type: GET_EXAM_BOARD_KURSES, payload: data });
    } catch (error) {
        console.error('Error in exam_board action:', error);
        dispatch({ type: GET_EXAM_BOARD_KURSES, payload: [] });
    }
};
//FILTERS